import request, { MethodEnum, serverTriggerUrl } from '@/utils/fetch';
import { AxiosProgressEvent } from 'axios';

interface IRecommendAvatarNameListReq {
  startId?: number;
  size?: number;
}

export interface IAvatar {
  id: number;
  attachment: string;
  image_url: {
    large: string;
    medium: string;
    small: string;
  };
  name: string;
}

export interface INickName {
  id: number;
  name: string;
  version: string;
}

interface IRecommendAvatarNameListRes {
  avatar_list: IAvatar[];
  max_nick_name_id: number;
  nick_name_list: INickName[];
}

/** 获取默认头像及昵称列表接口 */
export const getRecommendAvatarNameList = (params: IRecommendAvatarNameListReq): Promise<IRecommendAvatarNameListRes> => {
  return request({
    url: `/recommend/avatar-name-list`,
    method: MethodEnum.GET,
    params,
  })
    .then((data) => data.item)
    .catch((e) => Promise.reject(e));
};

export interface IUploadAvatarReq {
  file: File;
  controller?: AbortController,
  timeout?: number,
  onUploadProgressCb?: (percent: number)=>void
}

/** 上传头像 */
export const uploadAvatarService = ({
  file,
  controller,
  timeout,
  onUploadProgressCb,
}: IUploadAvatarReq): Promise<{key: string, url: string}> => {
  const formData = new FormData();
  formData.append('file', file);
  return request({
    url: '/forum/files/user-head/upload',
    method: MethodEnum.POST,
    params: formData,
    signal: controller?.signal,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    timeout,
    onUploadProgress: (progress: AxiosProgressEvent) => {
      const { loaded, total } = progress;
      if (total && typeof onUploadProgressCb === 'function') {
        onUploadProgressCb(Number(loaded/total));
      }
    },
  }).then((data) => {
    return data?.item;
  }).catch((e) => Promise.reject(e));
};

interface IusersUpdateReq {
  attachment: string;
  nick_name: string;
  operation_name_id?: number | null;
}

interface IusersUpdateRes {
  uuid: string;
  name: string;
  imageUrl: {
    large: string;
    medium: string;
    small: string;
  }
}

/** 修改用户信息 */
export const usersUpdateService = (params: IusersUpdateReq, timeout?: number): Promise<IusersUpdateRes> => {
  return request({
    url: `/users/update`,
    method: MethodEnum.POST,
    params,
    timeout,
  })
    .then((data) => data.item)
    .catch((e) => Promise.reject(e));
};

/** 更新用户配置（复用 /users/update；用于飞行里程公开开关等） */
export const userUpdateConfigService = (params: { hide_distance: boolean }) => {
  return request({
    url: `/users/update`,
    method: MethodEnum.POST,
    params,
  }).then((data) => data.item).catch((e) => Promise.reject(e));
};
